// Local translations
export const T = {
  en_GB: {
    noDataAvailable: "No expected value data available for this portfolio.",
    summary: "Summary",
    year: "Year",
    deposits: "Deposits",
    withdrawals: "Withdrawals",
    returns: "Returns",
    value: "Value",
    month: "Month",
    deposit: "Deposit",
    withdrawal: "Withdrawal",
    return: "Return",
    calculated: (time: string) => `Calculated ${time}`,
  },
  nb_NO: {
    noDataAvailable: "Ingen forventet verdidata tilgjengelig for denne porteføljen.",
    summary: "Sammendrag",
    year: "År",
    deposits: "Innskudd",
    withdrawals: "Uttak",
    returns: "Avkastning",
    value: "Verdi",
    month: "Måned",
    deposit: "Innskudd",
    withdrawal: "Uttak",
    return: "Avkastning",
    calculated: (time: string) => `Beregnet ${time}`,
  },
} as const;
